import Pencil from './Pencil';

export default Pencil;
